import { render, staticRenderFns } from "./DeptRoleInfo.vue?vue&type=template&id=a39056f2&scoped=true&"
import script from "./DeptRoleInfo.vue?vue&type=script&lang=js&"
export * from "./DeptRoleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39056f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a39056f2')) {
      api.createRecord('a39056f2', component.options)
    } else {
      api.reload('a39056f2', component.options)
    }
    module.hot.accept("./DeptRoleInfo.vue?vue&type=template&id=a39056f2&scoped=true&", function () {
      api.rerender('a39056f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DeptRoleInfo.vue"
export default component.exports